// The LN2 side of an adapter mapping entry, as data.
//
// WHY THIS IS NOT IN Ln2MappingEditor.tsx
//
// It used to be, and `Ln2MappingEditor.tsx` re-exports both names so every
// existing importer still works. But a React component file is a runtime
// dependency on React, Ant Design and this file's sibling pickers, and
// `lobbyVision2CdoBuilder.ts` imports `defaultLn2MappingData` as a VALUE — so
// the pure, headless FlatBuffer builder transitively required the whole editor
// UI to load.
//
// That is invisible inside the app, where everything is bundled anyway. It is
// very visible outside it: any Node consumer of the builder — demo CDO
// generators, one-off scripts, tooling — had to be configured to parse JSX, and
// `demos/routable_e2e` failed with `SyntaxError: Unexpected token '<'` the first
// time a script imported the builder for real. The old workaround was for each
// script to re-implement the builder instead, which is how demo fixtures drift
// away from the code they are supposed to be exercising.
//
// A data interface and its blank-value factory have no reason to live in a
// component file. Keeping them here means the builder's runtime graph contains
// no `.tsx` at all, and stays that way.
import { FbMessageRef } from "../../../interfaces/FbMessage.interface";

/**
 * Unified data model for the LN2 side of a mapping entry.
 *
 * Every adapter (Modbus, OPC, Sequent, LN1, BACnet, Numato, STM32, etc.)
 * stores its vendor-specific fields separately, but the LN2 output always
 * requires these fields. The `Ln2MappingEditor` component reads and writes
 * this interface.
 */
export interface Ln2MappingData {
  /** UUID of the target bank. */
  bank_id: string;
  /** Human-readable bank name. */
  bank_name: string;
  /** UUID of the target lift/car within the bank. */
  lift_id: string;
  /** Human-readable lift/car name. */
  lift_name: string;
  /** The LN2 valued message reference (category + variant + value + device type). */
  message: FbMessageRef | null;
}

/** Construct a blank `Ln2MappingData` with empty/null fields. */
export function defaultLn2MappingData(): Ln2MappingData {
  return {
    bank_id: "",
    bank_name: "",
    lift_id: "",
    lift_name: "",
    message: null,
  };
}
